import {
    ClaimType,
    CombinedClaimReceiptStatus,
    ExpenseCategory,
    FormDocumentType,
    FormDocumentPlan,
    HsabAccountNametag,
    HsabAccountType,
    HsabDocumentType,
    HsabExpenseCategory,
    HsabExpenseOriginator,
    HsabPlanSubType,
    HsabPlanType
} from "@/shared/types";

export const planSubTypeIconMap: Record<HsabPlanSubType, string> = {
    none: "",
    retirementHra: "fa-handshake",
    lifestyleSpendingAccount: "fa-dumbbell",
    wellnessHra: "fa-apple-whole",
    adoptionFsa: "fa-baby",
    limitedPurposeFsa: "fa-tooth",
    educationHra: "fa-user-graduate"
};
export const planTypeIconMap: Record<HsabPlanType, string> = {
    unknown: "fa-question",
    medicalFlex: "fa-kit-medical",
    dependentCare: "fa-child-reaching",
    healthReimbursementAccount: "fa-hand-holding-heart",
    healthSavingAccount: "fa-piggy-bank",
    commuterParking: "fa-car",
    commuterTransit: "fa-train-subway",
};
const claimTypeIconMap: Record<ClaimType, string> = {
    none: "fa-cart-shopping",
    medical: "fa-suitcase-medical",
    pharmacy: "fa-capsules",
    dental: "fa-tooth",
    vision: "fa-glasses",
};
const formDocumentTypeIconMap: Record<FormDocumentType, string> = {
    none: "fa-file",
    document: "fa-file",
    link: "fa-link"
};
export function formDocumentTypeIcon (docType: FormDocumentType): string {
    return formDocumentTypeIconMap[docType];
}
const expenseCategoryIconMap: Record<string, string> = {
    // --- ExpenseCategory ---
    none: "fa-cart-shopping",
    dental: "fa-tooth",
    medical: "fa-suitcase-medical",
    eye: "fa-glasses",
    pharmacy: "fa-capsules",
    other: "fa-cart-shopping",
    // --- HsabExpenseCategory ---
    unknown: "fa-circle-question",
    // medical: "fa-suitcase-medical", duplicate shared by both enums
    // dental is shared
    vision: "fa-eye",
    // pharmacy is shared
    dependentCare: "fa-child-reaching",
    parking: "fa-car-side",
    massTransit: "fa-bus",
    premium: "fa-money-bills",
    tuition: "fa-graduation-cap",
    lifestyle: "fa-person-running",
};
const expenseSourceIconMap: Record<string, string> = {
    unknown: "fa-circle-question",
    recurringExpense: "fa-repeat",
    carrierClaim: "fa-hospital-user",
    consumer: "fa-receipt",
    debitCard: "fa-credit-card",
    administrator: "fa-headset"
};
export const docTypeIconMap: Record<HsabDocumentType, string> = {
    none: "fa-question",
    tax: "fa-file-invoice-dollar",
    nonHsaAccountSummary: "fa-file",
    accountSummary: "fa-piggy-bank",
};
export const wexClaimReceiptStatusIcon: Record<CombinedClaimReceiptStatus, string> = {
    none: "",
    applied: "cloud-upload",
    complete: "bank",
    denied: "times-circle",
    hold: "pause-circle",
    locked: "lock",
    newReceiptNeeded: "info-circle",
    pending: "clock",
    pendingReceipt: "clock",
    pendingReimbursement: "clock",
    receiptOverdue: "hourglass-end",
    receiptNeeded: "edit",
    resubmitted: "recycle",
    scheduledReimbursement: "clock",
    submitted: "rocket",
    expired: "ban",
    unsubmitted: "diamond",
    markedAsPaid: "bank",
    repaid: "Repaid",
    repaymentDue: "Repayment Due"
};
export function hsaPlanTypeIcon (): string {
    return "fa-piggy-bank";
}

export function hsabAccountIcon (account: HsabAccountNametag): string {
    if (account.bankAccountType === HsabAccountType.Hsa) {
        return hsaPlanTypeIcon();
    } else {
        const subIcon = planSubTypeIconMap[account.planSubType];
        if (subIcon) {
            return subIcon;
        }
        return planTypeIconMap[account.planType];
    }
}

export function resourceDocumentIcon (formDocumentPlan: FormDocumentPlan): string {
    const subIcon = planSubTypeIconMap[formDocumentPlan.planSubType];
    if (subIcon) {
        return subIcon;
    }
    return planTypeIconMap[formDocumentPlan.planType];
}

export function claimTypeIcon (claimType: ClaimType): string {
    return claimTypeIconMap[claimType];
}

export function expenseCategoryIcon (claimType: ExpenseCategory | HsabExpenseCategory): string {
    return expenseCategoryIconMap[claimType];
}

export function expenseSourceIcon (source: HsabExpenseOriginator): string {
    return expenseSourceIconMap[source];
}